"use client"
import React, { Fragment, useState, useEffect } from "react";

import { useAppData } from "@/lib/providers/AppDataProvider";

import "@/components/categories/ProfileTypeFilterv2.css";
import { useMediaQuery } from "react-responsive";
import Select from "react-select";

const ProfileTypeFilterv2 = ({
  className,
  type,
  values,
  onChange,
  selected,
  multiple,
  renderAll = true
}) => {
  const isSm = useMediaQuery({ maxWidth: 767.98 });

  const [entries, setEntries] = useState(null);
  const [selectedEntry, setSelectedEntry] = useState(null);
  const { flattenedProfileTypes: profileTypes } = useAppData();

  useEffect(() => {
    if (values && values.length > 0 && profileTypes.length > 0) {
      var newEntries = [];
      values.forEach((value, index) => {
        var entry = profileTypes.find(pt => pt.value === value);
        if (entry) {
          // the entries contain an options object that is empty, so
          // I needed to create new objects that did not have the options
          // property defined so it would render properly in react-select for mobile
          newEntries.push({
            label: entry.label,
            value: entry.value,
            icon: entry.icon
          });
        }
      });
      if (!multiple && renderAll) {
        newEntries.unshift({ label: "All", value: null });
      }
      setEntries(newEntries);
    } else {
      setEntries(null);
    }
  }, [values, profileTypes]);

  const toggle = entry => {
    if (multiple) {
      var newSelected = selectedEntry ? [...selectedEntry] : [];
      var index = newSelected.findIndex(s => s === entry.value);
      if (index > -1) {
        newSelected.splice(index, 1);
      } else {
        newSelected.push(entry.value);
      }
      setSelectedEntry(newSelected);
      onChange(newSelected);
    } else {
      setSelectedEntry(entry ? entry.value : null);
      onChange(entry.value ? entry : null);
    }
  };

  useEffect(() => {
    if (selected) {
      setSelectedEntry(selected);
    }
  }, []);

  const entryClassName = entry => {
    if (multiple) {
      return selectedEntry
        ? selectedEntry.findIndex(v => v === entry.value) > -1
          ? "selected"
          : ""
        : "";
    } else {
      return selectedEntry === entry.value ? "selected" : "";
    }
  };

  const elements = () => {
    var theElements = entries.map((entry, index) => {
      return (
        <Fragment key={index}>
          <span
            className={`entry ${entryClassName(entry)}`}
            onClick={() => toggle(entry)}
          >
            {entry.icon && <i className={`fa-solid fa-${entry.icon}`}></i>}
            <span className="text">{entry.label}</span>
          </span>
        </Fragment>
      );
    });
    return theElements;
  };

  if (!entries) return <></>;
  else {
    if (isSm) {
      return (
        <Select
          id="profile-type-filter-select"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: base => ({
              ...base,
              zIndex: 9999
            })
          }}
          className="select basic-single"
          classNamePrefix="btn-secondary-select"
          name="selectedEntry"
          isSearchable={false}
          isClearable={false}
          options={entries}
          value={entries.find(e => e.value === selectedEntry)}
          defaultValue={entries[0]}
          onChange={option => toggle(option)}
        />
      );
    } else {
      return (
        <div className={`profile-type-filter-v2 ${className}`}>
          <>{elements()}</>
        </div>
      );
    }
  }
};
export default ProfileTypeFilterv2;
